var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Popover } from 'react-tiny-popover';
import PublishPopOverBody from './SharePopOverBody';
import { faShareSquare } from '@fortawesome/pro-solid-svg-icons/faShareSquare';
import { TooltipTopBar } from '../utils/tooltipConfig';
var PublishPopOver = function (_a) {
    var isVisible = _a.isVisible, setIsVisible = _a.setIsVisible, closePublishPopOver = _a.closePublishPopOver, handleInviteModalOpen = _a.handleInviteModalOpen, appId = _a.appId;
    return (_jsx(Popover, __assign({ isOpen: isVisible, positions: ['bottom'], align: "end", content: _jsx(PublishPopOverBody, { handleInviteModalOpen: handleInviteModalOpen, appId: appId }), onClickOutside: function () { return setIsVisible(false); } }, { children: _jsx("div", __assign({ onClick: function () {
                setIsVisible(!isVisible);
                closePublishPopOver();
            } }, { children: _jsx(TooltipTopBar, __assign({ title: "Share Project" }, { children: _jsx(FontAwesomeIcon, { color: "#FFFFFF", icon: faShareSquare, style: {
                        fontSize: '20px',
                        marginRight: '5px',
                        marginLeft: '22px',
                        cursor: 'pointer',
                    } }) })) })) })));
};
export default PublishPopOver;
